import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';

const RecentActivity = ({ recentActivity }) => {
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getActivityIcon = (action) => {
        switch (action) {
            case 'created':
                return 'bi-plus-circle text-success';
            case 'updated':
                return 'bi-pencil-square text-primary';
            case 'deleted':
                return 'bi-trash text-danger';
            case 'login':
                return 'bi-box-arrow-in-right text-info';
            default:
                return 'bi-clock-history text-muted';
        }
    };

    return (
        <Card>
            <Card.Header className="bg-secondary text-white">
                <h5 className="mb-0">
                    <i className="bi bi-clock-history me-2"></i>
                    Recent User Management Activity (48hrs)
                </h5>
            </Card.Header>
            <Card.Body>
                {recentActivity.length === 0 ? (
                    <div className="text-center py-4 text-muted">
                        <i className="bi bi-inbox display-1"></i>
                        <div className="mt-2">No recent activity</div>
                    </div>
                ) : (
                    <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
                        <Table responsive hover>
                            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                                <tr>
                                    <th>Action</th>
                                    <th>Description</th>
                                    <th>Creator</th>
                                    <th>Timestamp</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recentActivity.map((activity, index) => (
                                    <tr key={index}>
                                        <td>
                                            <i className={`bi ${getActivityIcon(activity.activity_type)} me-2`}></i>
                                            <span className="text-capitalize">{activity.activity_type}</span>
                                        </td>
                                        <td>
                                            {activity.description}
                                        </td>
                                        <td>{activity.user_name}</td>
                                        <td className="text-muted">
                                            {formatDate(activity.activity_date)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default RecentActivity;
